import {
  FETCH_PROJECTS,
  SET_SEARCH,
  SET_SELECTED,
  SET_SELECT,
  FETCH_PROJECT_LIST_ACTION,
  CLEAR_PROJECTS
} from '@/system/store/action-types'

import {
  SET_PROJECTS,
  SEARCH,
  SET_SELECTED_PROJECT,
  SET_SELECT_PROJECT_TYPE
} from '@/system/store/mutation-types'

import {
  IProjectStore,
  ISelectSystem,
  ISelectedProjects
} from '@/features/projectList/store'

import { Action, ActionTree, Commit } from 'vuex'
import WebSocketService from '@/system/socket/socket.service'

const projectListService = new WebSocketService()

const setSearch: Action<IProjectStore, any> = (context: { commit: Commit }, search: string) => {
  return context.commit(SEARCH, search)
}

const setSelect: Action<IProjectStore, any> = (context: { commit: Commit }, select: ISelectSystem) => {
  return context.commit(SET_SELECT_PROJECT_TYPE, select)
}

const fetchProjects: Action<IProjectStore, any> = (context: { commit: Commit }, { projectList: projects }: any) => {
  return context.commit(SET_PROJECTS, projects)
}

const clearProjects: Action<IProjectStore, any> = (context: { commit: Commit }) => {
  return context.commit(SET_PROJECTS, { items: [], count: 0 })
}

const setSelected: Action<IProjectStore, any> = (context: { commit: Commit}, selected: ISelectedProjects[]) => {
  return context.commit(SET_SELECTED_PROJECT, selected)
}

const fetchProjectListAction: Action<IProjectStore, any> = (context: { commit: Commit}) => {
  return projectListService.fetchProjectList()
}

const actions: ActionTree<IProjectStore, any> = {
  [ FETCH_PROJECTS ]: fetchProjects,
  [ SET_SEARCH ]: setSearch,
  [ SET_SELECTED ]: setSelected,
  [ SET_SELECT ]: setSelect,
  [ FETCH_PROJECT_LIST_ACTION ]: fetchProjectListAction,
  [ CLEAR_PROJECTS ]: clearProjects
}

export default actions
